<div class="ref-panel">
  <div class="sticky-header">
    <div class="modal-header">
      <button class="btn-ghost" (click)="goBack()">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
             stroke-linecap="round" stroke-linejoin="round" class="btn-ghost-icon">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        Back
      </button>
      <h2 class="title">My Referrals</h2>
      <div class="header-spacer"></div>
    </div>

    <div class="ref-list-head">
      <span>User</span>
      <span>Transactions</span>
    </div>
  </div>

  <div class="scrollable-body">
    <div *ngIf="isReferralsLoaded && (!referrals || referrals.length === 0)" class="no-records">
      No records found yet
    </div>

    <div *ngIf="referrals && referrals.length > 0" class="ref-list">
      <div *ngFor="let user of referrals" class="ref-item">

        <div class="user-info">
          <span class="user-avatar">{{ (user.UserName || '?').charAt(0) | uppercase }}</span>
          <span class="user-name">{{ user.UserName }}</span>
        </div>

        <div class="tx-info">
          <span class="badge">{{ user.TotalTransactions }}</span>
          <button class="btn-view" (click)="viewTransactions(user)">
            View Details
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="isTransactionModalOpen" class="modal-overlay" (click)="closeTransactionModal()">
  <div class="tx-modal" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="tx-modal-header">
      <div class="tx-modal-title">
        <span class="tx-title-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M3 10h18M7 15h4M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
          </svg>
        </span>
        <div>
          <h2 class="tx-heading">Transactions</h2>
          <span class="tx-subheading" *ngIf="selectedUser">
            {{ selectedUser.UserName }}
          </span>
        </div>
      </div>
      <button class="tx-close" (click)="closeTransactionModal()" aria-label="Close">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
             stroke-linecap="round" stroke-linejoin="round">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>

    <!-- Summary -->
    <div class="tx-summary" *ngIf="transactionDetails && transactionDetails.length > 0">
      <div class="tx-summary-cell">
        <span class="tx-summary-label">Transactions</span>
        <span class="tx-summary-value">{{ transactionDetails.length }}</span>
      </div>
      <div class="tx-summary-divider"></div>
      <div class="tx-summary-cell">
        <span class="tx-summary-label">Total Amount</span>
        <span class="tx-summary-value tx-summary-amount">
          ${{ getTransactionsTotal() }}
        </span>
      </div>
    </div>

    <!-- Body -->
    <div class="tx-body">
      <div *ngIf="isTransactionsLoaded && (!transactionDetails || transactionDetails.length === 0)"
           class="tx-empty">
        <span class="tx-empty-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"
               stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9" />
            <path d="M8 12h8" />
          </svg>
        </span>
        No transactions found yet
      </div>

      <div *ngIf="transactionDetails && transactionDetails.length > 0" class="tx-list">
        <div *ngFor="let tx of transactionDetails" class="tx-row">
          <div class="tx-row-user">
            <span class="tx-avatar">{{ (tx.CustomerName || '?').charAt(0) | uppercase }}</span>
            <div class="tx-row-meta">
              <span class="tx-row-name">{{ tx.CustomerName }}</span>
              <span class="tx-row-tag">Referred player</span>
            </div>
          </div>
          <span class="tx-amount">
            <span class="tx-amount-sign">$</span>{{ tx.Balance }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
